import { useState } from 'react';
import { useDebounce } from 'use-debounce';

export interface ControlFunctions {
  cancel: () => void;
  flush: () => void;
  isPending: () => boolean;
}

export type IuseDebounceHook = (
  initialValue: string,
  seconds: number
) => [
  string,
  string,
  React.Dispatch<React.SetStateAction<string>>,
  ControlFunctions
];

export const useDebounceState: IuseDebounceHook = (initialVal, seconds) => {
  const [state, setState] = useState<string>(initialVal);
  const [debounceState, funuctions] = useDebounce<string>(state, seconds);
  return [state, debounceState, setState, funuctions];
};
